import AllTab from "./AllTab";
import SidebarArea from "../blogSingle/SidebarArea";

const LatestArticles = () => {
  return (
    <section className="latest-articles blog blog-2 blog-3">
      <div className="overlay pb-120">
        <div className="container">
          <div className="section-header">
            <div className="row justify-content-between">
              <div className="col-lg-8">
                <h2 className="title">Latest Articles</h2>
                <div className="tab-content" id="myTabContent">
                  {/* All Tab */}
                  <AllTab />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 position-sticky top-0">
                {/* Sidebar Area */}
                <SidebarArea />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestArticles;
